export default __webpack_public_path__ + "static/media/Cap of a Thousand Blossoms.25f4dfc1.jpg";